import { useContext } from 'react'
import BookingList from './booking-list'
import { BookingSubheading } from './booking-list-styles'
import { ApiContext } from '../../contexts/api-context'

const UserBookings = () => {
  const { getUserBooking } = useContext(ApiContext)

  const userBookingData = getUserBooking()
  const bookingsLength = userBookingData.length
  const bookingText = bookingsLength === 1 ? 'booking' : 'bookings'

  return (
    <>
      <BookingSubheading>
        You have <strong>{!bookingsLength ? 'no ' : `${bookingsLength} `}</strong>
        {bookingText} confirmed
      </BookingSubheading>
      {userBookingData.length > 0 && <BookingList bookingList={userBookingData} />}
    </>
  )
}

export default UserBookings
